var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialogs"},[_c('DialogOversold'),_c('DialogOrderError'),_c('DialogAppUpdate'),_c('DialogPlacingOrder'),_c('DialogCartDatePicker'),_c('DialogUpdateTimezone'),_c('OrderPrepDatePicker')],1)}
var staticRenderFns = []

export { render, staticRenderFns }